import styled, { keyframes } from "styled-components";
import checkIcon from "assets/icons/check-w.svg";
import { Flex } from "Element/Flex";
import { ReactComponent as LoadingSvg } from "assets/images/loading.svg";
export const MintInfo = styled.span`
  text-align: center;
  margin-bottom: 56px;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
      margin-bottom: 32px;
  `}
`;

export const StyledCheckBox = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid ${({ theme }) => theme.colors.neutral80};
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  margin-right: 8px;
  &:checked {
    background-image: url(${checkIcon});
    background-color: ${({ theme }) => theme.colors.secondary60};
    border-color: ${({ theme }) => theme.colors.secondary60};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
      width: 20px;
      height: 20px;
  `}
`;

export const TermsText = styled.div`
  color: ${({ theme }) => theme.colors.neutral80};
  ::after {
    content: "By checking this box, I agree to Doge’s Terms of Service";
    ${({ theme }) => theme.mediaWidth.upToSmall`
        content: "I agree to Doge’s Terms of Service";
      `}
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
      font-size: 15px;
  `}
`;

export const ButtonWrapper = styled(Flex)`
  .second-btn {
    padding: 10px 40px;
    margin-right: 36px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      
        margin-right: 0;
        margin-bottom: 16px;
      
    `}
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 0;
  `}
`;

export const RotateAnimation = keyframes`
  from{
    transform: rotate(-90deg)
  }
  to{
    transform: rotate(270deg)

  }
`;

export const LoadingWrapper = styled(Flex)`
  position: relative;
  align-items: center;
`;

export const DogeHead = styled.img`
  position: absolute;
  margin: auto;
  z-index: 1;
  width: 120px;
`;

export const LoadingCircle = styled(LoadingSvg)`
  animation: ${RotateAnimation} 5s linear infinite;
`;
